// This file is auto-generated by @hey-api/openapi-ts
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { client } from "./client.gen";
export var postApiCreateFolder = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/CreateFolder" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiDeleteFolder = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/DeleteFolder" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var getApiGetSystemsAndFolders = function (options) {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get(__assign({ url: "/api/GetSystemsAndFolders" }, options));
};
export var postApiUpdateFolder = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/UpdateFolder" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiCreateConfiguration = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/CreateConfiguration" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var getApiGetConfiguration = function (options) {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get(__assign({ url: "/api/GetConfiguration" }, options));
};
export var postApiClaimSystemCopy = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/ClaimSystemCopy" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiCreateSystem = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/CreateSystem" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiDeleteSystem = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/DeleteSystem" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var getApiGetSystemData = function (options) {
    var _a;
    return ((_a = options.client) !== null && _a !== void 0 ? _a : client).get(__assign({ url: "/api/GetSystemData" }, options));
};
export var postApiShareSystemCopy = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/ShareSystemCopy" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiUpdateSystem = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/UpdateSystem" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
export var postApiDeleteFlaggedSystems = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign({ url: "/api/DeleteFlaggedSystems" }, options));
};
export var postApiMigrateSystemsToRoot = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign({ url: "/api/MigrateSystemsToRoot" }, options));
};
export var postApiSendEmail = function (options) {
    var _a;
    return ((_a = options === null || options === void 0 ? void 0 : options.client) !== null && _a !== void 0 ? _a : client).post(__assign(__assign({ url: "/api/sendEmail" }, options), { headers: __assign({ "Content-Type": "application/json" }, options === null || options === void 0 ? void 0 : options.headers) }));
};
